import React, { useEffect, useState } from 'react';
import FullscreenDialog from 'Components/UI/FullscreenDialog';
import useLinkModal from 'Components/Modals/LinkModal/useLinkModal';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { makeStyles } from '@material-ui/core';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import BulkCommunicationLayout from 'Components/Modals/BulkCommunicationDialog/BulkCommunicationLayout';
import { BulkCommunicationFilterProvider } from 'Components/Modals/BulkCommunicationDialog/BulkCommunicationFilterContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import BulkCommunicationPreviewDialog from 'Components/Modals/BulkCommunicationDialog/BulkCommunicationPreviewDialog';
import { QueryVal } from 'Helpers/Query';
import MyOutgoingMessages from 'Components/Modals/BulkCommunicationDialog/components/MyOutgoingMessages';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.dimensions.xxxxl,
    alignContent: 'center',
    display: 'flex',
    padding: theme.spacing(5, 10),
  },
  formRoot: {
    maxWidth: theme.dimensions.xxl,
  },
  loading: {
    textAlign: 'center',
  },
  sideBar: {

  },
  sideBarItem: {
    marginBottom: theme.spacing(4),
  },
}));

const BulkCommunicationDialog = ({ ...rest }) => {
  const classes = useStyles();

  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Bulk Communication',
    isPageView: true,
  });

  const [showPreview, setShowPreview] = useState(false);
  const type = 'bulkCommunication';
  const link = 'bulkCommunicationLink';

  const bulkCommunicationPreviewLink = QueryVal('bulkCommunicationPreviewLink');

  const {
    collection,
    handleClose,
  } = useLinkModal({
    link,
    type,
    onSubmit: async () => { },
  });

  useEffect(() => {
    if (bulkCommunicationPreviewLink) {
      setShowPreview(true);
    } else {
      setShowPreview(false);
    }
  }, [bulkCommunicationPreviewLink]);


  return (
    <>
      <FullscreenDialog
        disableEnforceFocus // Allows CKEditor to have its own modals
        title="Select Clients"
        variant="white"
        test="bulk-communication-modal"
        CloseButtonProps={{
          test: 'bulk-communication-close-modal',
        }}
        {...rootNodeProps}
      >
        <BulkCommunicationFilterProvider>
          {!collection ? (
            <div className={classes.loading}>
              <LoadingIndicator />
            </div>
          ) : (
            <div className={classes.root}>
              <MetaCollectionFormInline
                classes={{
                  root: classes.formRoot,
                  form: classes.form,
                }}
                onClose={handleClose}
                collection={collection}
                title=""
                FormProps={{
                  noIndividualSubmitButtons: true,
                  layout: BulkCommunicationLayout,
                }}
                {...rest}
              />
              { !collection.resources()?.head()?.link('self') && (
              <div className={classes.sideBar}>
                <div className={classes.sideBarItem}>
                  <MyOutgoingMessages />
                </div>
              </div>
              )}
            </div>
          )}
        </BulkCommunicationFilterProvider>
      </FullscreenDialog>
      {showPreview && <BulkCommunicationPreviewDialog />}
    </>
  );
};

export default BulkCommunicationDialog;
